"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORCAClient = void 0;
const aws_api_gateway_client_1 = require("aws-api-gateway-client");
const pkg_cruise_api_endpoint_1 = require("pkg-cruise-api-endpoint");
const client_1 = require("../config/client");
class ORCAClient {
    getCurrentApiUrl(stageMapping) {
        const currentUrl = window &&
            window.location &&
            `${window.location.protocol}//${window.location.hostname}/api`;
        const validUrl = currentUrl && currentUrl.includes('https') && currentUrl;
        return validUrl || stageMapping.endpoint;
    }
    createClient(mapping) {
        // create invoke url based on mapping and current url
        const opts = {
            invokeUrl: this.getCurrentApiUrl(mapping[pkg_cruise_api_endpoint_1.stage]),
            region: 'eu-central-1',
        };
        return aws_api_gateway_client_1.default.newClient(opts);
    }
    restrictions(cruiseID) {
        return __awaiter(this, void 0, void 0, function* () {
            const pathTemplate = `/v0/restrictions/${cruiseID}`;
            const client = this.createClient(client_1.orcaEndpointMapping);
            const response = yield client.invokeApi({}, pathTemplate, 'GET', {
                headers: {
                    Authorization: this.getBasicAuth(client_1.orcaEndpointMapping),
                },
            }, {});
            const { status, data } = response;
            if (status === 200) {
                return data;
            }
            else {
                throw new Error(`statusCode: ${status}`);
            }
        });
    }
    getBasicAuth(mapping) {
        return mapping[pkg_cruise_api_endpoint_1.stage].apiKey;
    }
}
exports.ORCAClient = ORCAClient;
//# sourceMappingURL=orca.js.map